import { render, staticRenderFns } from "./DecoctingFee.vue?vue&type=template&id=be8823a2"
import script from "./DecoctingFee.vue?vue&type=script&lang=js"
export * from "./DecoctingFee.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\daima\\daima\\health-pharmacy\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('be8823a2')) {
      api.createRecord('be8823a2', component.options)
    } else {
      api.reload('be8823a2', component.options)
    }
    module.hot.accept("./DecoctingFee.vue?vue&type=template&id=be8823a2", function () {
      api.rerender('be8823a2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/business/page/manager/pharmacy/pharmacy/DecoctingFee.vue"
export default component.exports